import { Injectable } from '@angular/core'
import { SeEnvironmentUrlService } from 'se-fe-auth-support'
import { LaunchDarklyClient } from 'se-launchdarkly-js'
import { environment } from '@se-po/shared-environments'

@Injectable({
  providedIn: 'root'
})
export class LaunchDarklyService {

  constructor(private urlService: SeEnvironmentUrlService) {
    // noop
  }
  public client(orgId?: number): Promise<any> {
    return LaunchDarklyClient.client(
      environment.launchDarklyClientId,
      this.urlService.getApiUrl(),
      orgId
    )
  }
}
